import { CepModel } from './../../shared/service/cep/model/cep.model';
import { Injectable } from '@angular/core';
import { JourneyService } from '../../shared/service/journey/journey.service';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  private readonly STEP_CODE = 'address';
  public addressInitalPostCode: CepModel;
  public dataPersistence: any;

  constructor(private journeyService: JourneyService) {
  }

  public setAddressPostalCode(addressCep: string) {
    this.journeyService.registratioJourney.data.address.postalCode = addressCep;
  }

  public setAddressStreet(street: string) {
    this.journeyService.registratioJourney.data.address.street = street;
  }

  public setAddressNumber(numberAddress: string) {
    this.journeyService.registratioJourney.data.address.number = numberAddress;
  }

  public setAddressAdjunt(addressAdjunt: string) {
    this.journeyService.registratioJourney.data.address.adjunct = addressAdjunt;

    if (this.journeyService.registratioJourney.data.address.district
      && this.journeyService.registratioJourney.data.address.city
      && this.journeyService.registratioJourney.data.address.state) {
      this.dataPersistence = undefined;
      this.setIsCompleteStepData();
      this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.address);
    }
  }

  public setAddressDistrict(addressDistrict: string) {
    this.journeyService.registratioJourney.data.address.district = addressDistrict;

    if (this.journeyService.registratioJourney.data.address.city
      && this.journeyService.registratioJourney.data.address.state) {
      this.dataPersistence = undefined;
      this.setIsCompleteStepData();
      this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.address);
    }
  }

  public setAddressCity(addressCity: string) {
    this.journeyService.registratioJourney.data.address.city = addressCity;
    this.dataPersistence = undefined;

    if (this.journeyService.registratioJourney.data.address.state) {
      this.setIsCompleteStepData();
      this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.address);
    }
  }

  public setAddressCityName(addressCityName: string) {
    this.journeyService.registratioJourney.data.address.cityName = addressCityName;
  }

  public setAddressState(addressState: string) {
    if (addressState !== this.journeyService.registratioJourney.data.address.state) {
      this.journeyService.registratioJourney.data.address.city = undefined;
      this.journeyService.registratioJourney.data.address.cityName = undefined;
      this.journeyService.registratioJourney.data.address.state = addressState;
      return;
    } else {
      this.journeyService.registratioJourney.data.address.state = addressState;
    }

    if (this.journeyService.registratioJourney.data.address.city) {
      this.dataPersistence = undefined;
      this.setIsCompleteStepData();
      this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.address);
    }
  }

  public setAddressStateName(addressStateName: string) {
    this.journeyService.registratioJourney.data.address.stateName = addressStateName;
  }

  setIsCompleteStepData() {
    this.journeyService.registratioJourney.data.address.isCompleted = this.addressDataIsComplete();
  }

  addressDataIsComplete(): boolean {
    const props = ['postalCode', 'street', 'number', 'district', 'city', 'state'];
    const objAddress = {
      street: this.journeyService.registratioJourney.data?.address?.street,
      number: this.journeyService.registratioJourney.data?.address?.number,
      district: this.journeyService.registratioJourney.data?.address?.district,
      city: this.journeyService.registratioJourney.data?.address?.city,
      state: this.journeyService.registratioJourney.data?.address?.state,
    };

    return this.journeyService.registratioJourney.data.address !== undefined
      && this.isAllProps(this.journeyService.registratioJourney.data.address, props)
      && this.isNotEmpty(objAddress);
  }

  isAllProps(data: any, props: string[]): boolean {
    return props.every((prop) => data.hasOwnProperty(prop));
  }

  isNotEmpty(data: any): boolean {
    return Object.values(data).every(value => !!value);
  }
}
